"use client";

import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, Plus } from "lucide-react";
import { Button } from "@vionixasia/shared-components";
import { AdminShell } from "@/components/AdminShell";
import { StatCard } from "@/components/StatCard";
import { apiClient } from "@/lib/api-client";
import type { MessagingProject } from "@/types/project";

export default function DashboardPage() {
  const [projects, setProjects] = useState<MessagingProject[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient<{ projects: MessagingProject[] }>("/api/projects")
      .then((data) => setProjects(data.projects))
      .catch(() => setProjects([]))
      .finally(() => setLoading(false));
  }, []);

  const stats = useMemo(() => ({
    projects: projects.length,
    timing: projects.filter((project) => project.type === "timing_result").length,
    inbox: projects.filter((project) => project.type === "customer_service").length,
    ai: projects.filter((project) => project.type === "ai_agent").length,
  }), [projects]);

  return (
    <AdminShell>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold text-ink">Projects</h1>
          <p className="text-sm text-muted">Kelola project WhatsApp reusable untuk result notification, inbox, dan AI agent.</p>
        </div>
        <Button as={Link} to="/dashboard/projects/new" color="teal">
          <Plus size={16} /> Create Project
        </Button>
      </div>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard label="Total Project" value={stats.projects} />
        <StatCard label="Timing Result" value={stats.timing} />
        <StatCard label="Inbox Project" value={stats.inbox} />
        <StatCard label="AI Agent" value={stats.ai} />
      </div>
      <div className="mt-6 grid gap-4 md:grid-cols-2">
        {loading && <p className="text-sm text-muted">Loading projects...</p>}
        {!loading && projects.map((project) => (
          <Link key={project.id} className="rounded-card border border-line bg-white p-5 hover:border-brand" to={`/dashboard/project?projectId=${project.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div>
                <h2 className="font-semibold text-ink">{project.name}</h2>
                <p className="mt-1 text-sm text-muted">{project.slug} · {project.type} · {project.status}</p>
              </div>
              <MessageSquare className="text-brand" size={20} />
            </div>
            <p className="mt-4 text-sm text-muted">Default language: {project.default_template_language || "id"}</p>
          </Link>
        ))}
        {!loading && projects.length === 0 && <div className="rounded-card border border-line bg-white p-6 text-sm text-muted">Belum ada project WhatsApp.</div>}
      </div>
    </AdminShell>
  );
}
